import { useExperiment, useFeatureGate } from '@services/statsig';

import {
  GUIDE_LINKS_GATE,
  GUIDE_LINKS_HOLDOUT_EXPERIMENT,
  GUIDE_LINKS_HOLDOUT_PARAM,
} from '../constants/featureLinks';

export type FeatureLinksArm = 'treatment' | 'control';

export type FeatureLinksAccess = {
  /** The gate is open and the user is not in the holdout's control arm. */
  enabled: boolean;
  /** Null when the experiment is not configured or the user is not in it. */
  arm: FeatureLinksArm | null;
};

/** The gate alone. GuideLink skips the catalog on this before an article can resolve. */
export function useGuideLinksGate(): boolean {
  return useFeatureGate(GUIDE_LINKS_GATE);
}

function holdoutArm(linksEnabled: unknown): FeatureLinksArm | null {
  if (linksEnabled === true) return 'treatment';
  if (linksEnabled === false) return 'control';
  return null;
}

/**
 * Whether feature links show for this user: the gate, then the holdout arm
 * (GDN-3707, AC-18). Control sees the product exactly as outside the gate.
 *
 * The exposure is logged only inside the gate and only when `logExposure` is
 * true: GuideLink passes it for a Slice A or B surface once an article
 * resolved. The Help menu, the drawer mount and the drawer follow the arm
 * without counting as an exposure.
 */
export function useFeatureLinksAccess({
  logExposure,
}: {
  logExposure: boolean;
}): FeatureLinksAccess {
  const gate = useGuideLinksGate();
  const experiment = useExperiment(GUIDE_LINKS_HOLDOUT_EXPERIMENT, {
    disableExposureLog: !(gate && logExposure),
  });
  const arm = holdoutArm(experiment.value[GUIDE_LINKS_HOLDOUT_PARAM]);
  return { enabled: gate && arm !== 'control', arm };
}
